var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "warrant-message-container" }, [_c('el-badge', { staticClass: "badge", attrs: { "value": _vm.badge, "max": 99, "hidden": _vm.badge === 0 } }, [_c('pt-button', { staticClass: "warrant-message-enter message-button", attrs: { "type": "filled", "theme": "inverse", "size": "big", "mini": "", "icon": "" }, on: { "click": _vm.handleViewAll } }, [_c('ic-notification')], 1)], 1), _vm._v(" "), _c('message-drawer', { attrs: { "drawer": _vm.drawerVisible, "data": _vm.data }, on: { "update:drawer": function updateDrawer($event) {
        _vm.drawerVisible = $event;
      } } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };